import { Box, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Inputbox from "../../Components/Inputbox";
import { DropDownManuCustomMulti } from "../../Components/DropDownButton";
import {
  AddVisitReason,
  DeleteVisitReason,
  EditVisitReason,
  FetchCptcodes,
  FetchCptcodesforauth,
  FetchVisitReason,
} from "../../../api/helper";
import { ShowToast } from "../../../helpers/ToastService";
import DeleteModal from "../Components/DeleteModal";

const validationSchema = Yup.object().shape({
  visitReason: Yup.string().required("Visit Reason is required"),
  cptCode: Yup.array()
    .of(Yup.string().required("A CPT Code must be selected"))
    .min(1, "At least one CPT Code is required")
    .required("CPT Code is required"),
  appointmentDuration: Yup.string().required(
    "Appointment Duration is required"
  ),
});
const VisitReason = ({ GetTabStatus }) => {
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentEditData, setCurrentEditData] = useState(null);
  const [data, setData] = useState([]);
  const profileData = useSelector((state) => state?.cookies?.userDetails);
  const [modifiers, setModifiers] = useState(["", "", "", ""]);
  const [cptCodes, setcptCodes] = useState({
    data: [],
    pagination: { totalPages: 0 },
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [modal, setmodal] = useState(false);
  const [selectedCPTs, setSelectedCPTs] = useState([]);
  const [confirmdeletemodal, setconfirmdeletemodal] = useState(false);
  const [deleteId, setdeleteId] = useState(null);
  const pageSize = 50;

  const openModal = () => {
    setShowModal(true);
    setIsEditing(false);
    reset();
    setModifiers(["", "", "", ""]);
  };

  const closeModal = () => setShowModal(false);

  const {
    register,
    reset,
    handleSubmit,
    clearErrors,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const GetVisitReason = async () => {
    const response = await FetchVisitReason(`?id=${profileData?._id}`);
    setData(response?.data?.data);
  };
  const Getcptcodes = async (search = "", page = 1) => {
    try {
      const response = await FetchCptcodesforauth(search, page, pageSize);
      if (response?.data?.data) {
        setcptCodes({
          data: response.data.data,
          pagination: response.data.data.pagination || { totalPages: 0 },
        });
      } else {
        console.error("Unexpected API response structure");
        setcptCodes({ data: [], pagination: { totalPages: 0 } });
      }
    } catch (error) {
      console.log(error);
      setcptCodes({ data: [], pagination: { totalPages: 0 } });
    }
  };
  useEffect(() => {
    GetVisitReason();
    Getcptcodes();
  }, []);

  const handleModifierChange = (index, value) => {
    const updatedModifiers = [...modifiers];
    updatedModifiers[index] = value.slice(0, 2);
    setModifiers(updatedModifiers);
    setValue("modifiers", updatedModifiers, { shouldValidate: true });
  };

  const onSubmit = async (formData) => {
    formData.cptCode = formData.cptCode.join(",");
    formData.agencyId = profileData?._id;

    try {
      if (isEditing) {
        console.log(currentEditData, "currentEditData._id===");
        const response = await EditVisitReason(formData, currentEditData._id);
        ShowToast(response?.data?.message);
      } else {
        const response = await AddVisitReason(formData);
        console.log(response?.data?.data, "respose======");
        ShowToast(response?.data?.message);
      }
      reset();
      setModifiers(["", "", "", ""]);
      GetVisitReason();
      GetTabStatus();
      setShowModal(false);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleEdit = (row) => {
    setIsEditing(true);
    setCurrentEditData(row);
    setShowModal(true);

    setValue("visitReason", row.visitReason);
    setValue("appointmentDuration", row.appointmentDuration);
    setValue("reasonColor", row.reasonColor);
    setModifiers(row.modifiers?.length ? row.modifiers : ["", "", "", ""]);

    const selected = row.cptCode?.split(",").map((code) => code.trim()) || [];
    setSelectedCPTs(selected);

    setValue("cptCode", selected);
    trigger("cptCode");
  };

  const handleDelete = (id) => {
    setdeleteId(id);
    setconfirmdeletemodal(true);
  };

  const confirmDelete = async () => {
    setconfirmdeletemodal(false);
    try {
      const response = await DeleteVisitReason(`?id=${deleteId}`);
      if (response?.data?.success) {
        ShowToast(response?.data?.message);
        GetVisitReason();
        GetTabStatus();
      } else {
        ShowToast("Error: Unable to delete address.");
      }
    } catch (error) {
      console.error("Delete operation failed:", error);
      ShowToast("An error occurred while deleting the address.");
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    Getcptcodes(e.target.value);
  };
  const handelChange = (Service) => {
    const newItem = Service?.procCode;

    let updated;

    if (selectedCPTs.includes(newItem)) {
      // Remove if already selected
      updated = selectedCPTs.filter((item) => item !== newItem);
    } else {
      // Add new item
      updated = [...selectedCPTs, newItem];
    }

    setSelectedCPTs(updated);
    setValue("cptCode", updated); // update form
    trigger("cptCode");
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    Getcptcodes(searchTerm, page);
  };

  return (
    <div style={{ width: "100%", alignItems: "center", marginBottom: 20 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <h1>Visit Reasons and Codes</h1>
        <div
          className="add-button_user"
          style={{ height: 40 }}
          onClick={openModal}
        >
          Add Visit Reason
        </div>
      </div>
      <div style={{ overflowX: "auto", width: "100%", marginTop: 30 }}>
        <table className="table">
          <thead style={{ backgroundColor: "yellow" }}>
            <tr>
              <th>Sort #</th>
              <th>Reason & Color</th>
              <th>CPT Code(s)</th>
              <th>Appointment Duration</th>
              <th>Default Modifiers</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan="6"
                  style={{ textAlign: "center", padding: "10px" }}
                >
                  No Reason Found
                </td>
              </tr>
            ) : (
              [...data]
                .sort((a, b) => a.appointmentDuration - b.appointmentDuration)
                .map((row) => {
                  return (
                    <tr key={row._id} style={tableRowStyle}>
                      <td style={tableCellStyle}>{row.appointmentDuration}</td>
                      <td>
                        <div style={{ display: "flex" }}>
                          <div
                            className="Reason_Color"
                            style={{
                              backgroundColor: row.reasonColor,
                              borderRadius: 6,
                            }}
                          />
                          {row.visitReason}
                        </div>
                      </td>
                      <td style={tableCellStyle}>{row.cptCode}</td>
                      <td style={tableCellStyle}>
                        {row.appointmentDuration + " min"}
                      </td>
                      <td style={tableCellStyle}>
                        {row.modifiers.length > 0
                          ? row.modifiers.map((modifier, index) => (
                              <div key={index}>
                                {`M${index + 1}: ${modifier || ""}`}
                              </div>
                            ))
                          : "No Modifiers"}
                      </td>
                      <td style={tableCellStyle}>
                        <button
                          className="action_icon_btn"
                          title="Edit"
                          onClick={() => handleEdit(row)}
                        >
                          <i
                            className="fas fa-edit"
                            style={{ color: "black" }}
                          />
                        </button>
                        <button
                          className="action_icon_btn"
                          title="Delete"
                          style={{ backgroundColor: "white" }}
                          onClick={() => handleDelete(row._id)}
                        >
                          <i
                            className="fas fa-trash-alt"
                            style={{ color: "black" }}
                          />
                        </button>
                      </td>
                    </tr>
                  );
                })
            )}
          </tbody>
        </table>
      </div>
      <Modal
        open={showModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
      >
        <Box sx={modalStyle}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <h1 style={{ textAlign: "left" }}>Visit Reasons and Codes</h1>
            <Inputbox
              label="Visit Reason"
              name="visitReason"
              register={register}
              placeholder="Enter Visit Reason"
            />
            <p style={{ color: "red" }}>{errors.visitReason?.message}</p>
            <div class="form-group">
              <label for="reasonColor">Color</label>
              <input
                type="color"
                id="reasonColor"
                {...register("reasonColor")}
              />
              <span>Pick a color to represent this Visit Reason.</span>
            </div>
            <div className="form-column_insuranceDetails">
              <label style={{ fontWeight: "bold" }}>
                CPT Code (Select Multiple)
              </label>
              <input
                type="hidden"
                {...register("cptCode")}
                value={selectedCPTs.join(", ")}
              />
              <div
                onClick={() => setmodal(true)}
                style={{
                  borderWidth: 1,
                  borderStyle: "solid",
                  borderColor: "#ccc",
                  borderRadius: "5px",
                  minHeight: "43px",
                  padding: "10px",
                  display: "flex",
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                  gap: "5px",
                  cursor: "pointer",
                }}
                className="form-column_insuranceDetails_div"
              >
                {selectedCPTs.length > 0 ? (
                  selectedCPTs.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        backgroundColor: "#e0e0e0",
                        padding: "5px 10px",
                        borderRadius: "15px",
                        display: "flex",
                        alignItems: "center",
                        margin: "5px",
                      }}
                    >
                      {item}
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          const updated = selectedCPTs.filter(
                            (i) => i !== item
                          );
                          setSelectedCPTs(updated);
                          setValue("cptCode", updated);
                          trigger("cptCode");
                        }}
                        style={{
                          marginLeft: "8px",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        ×
                      </span>
                    </div>
                  ))
                ) : (
                  <div style={{ color: "grey" }}>Select Service Code</div>
                )}
              </div>
              {errors.cptCode && (
                <p className="error">{errors.cptCode.message}</p>
              )}
            </div>

            {/* <DropDownManuCustomMulti
              label="CPT Code (Select Multiple)"
              options={cptCodes}
              name="cptCode"
              register={register}
              id="name"
              clearErrors={clearErrors}
              onSelect={handleLanguage}
              // defaultValue={row&&row?.cptCode}
            /> */}

            <Inputbox
              label="Default Appointment Duration (minutes)"
              type="number"
              name="appointmentDuration"
              register={register}
              placeholder="Enter Duration in Minutes"
            />
            <p style={{ color: "red" }}>
              {errors.appointmentDuration?.message}
            </p>

            <div style={{ fontWeight: "bold", fontSize: 19 }}>
              Default Modifiers (Optional)
            </div>
            <div style={{ display: "flex", gap: "5%" }}>
              {modifiers.map((modifier, index) => (
                <Inputbox
                  key={index}
                  label={`Mod${index + 1}`}
                  placeholder="XX"
                  value={modifier}
                  onChange={(e) => handleModifierChange(index, e.target.value)}
                />
              ))}
            </div>

            <button type="submit" className="Save_buttonnn">
              {isEditing ? "Update" : "Save"}
            </button>
          </form>
        </Box>
      </Modal>
      <Modal
        open={modal}
        onClose={() => {
          setmodal(false);
        }}
        aria-labelledby="modal-title"
      >
        <Box sx={modalinsuranceStyle}>
          <div>
            <Inputbox
              label={"Search Cpt Codes"}
              placeholder={"Type to search..."}
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <div style={{ marginTop: 20 }}>
              {cptCodes?.data?.data?.length > 0 ? (
                cptCodes?.data?.data?.map((cpt) => {
                  return (
                    <div
                      key={cpt._id}
                      className="diagnosis-item"
                      onClick={() => handelChange(cpt)}
                      style={{
                        backgroundColor: selectedCPTs.includes(cpt.procCode)
                          ? "#d0f0d0"
                          : "#fff",
                        cursor: "pointer",
                        padding: "10px",
                        marginBottom: "5px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                      }}
                    >
                      <div>
                        <strong>Code:</strong> {cpt.procCode}
                      </div>
                      <div>
                        <strong>Description:</strong> {cpt.procDescription}
                      </div>
                    </div>
                  );
                })
              ) : (
                <p>No Cpt Codes available.</p>
              )}
            </div>

            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* Previous Button */}
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                style={{
                  margin: "5px",
                  padding: "10px 20px",
                  backgroundColor: currentPage === 1 ? "#ccc" : "#007BFF",
                  color: "#fff",
                  border: "1px solid #007BFF",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                }}
              >
                Previous
              </button>

              <span
                style={{
                  margin: "5px",
                  padding: "10px 20px",
                  backgroundColor: "#fff",
                  color: "#000",
                  border: "1px solid #007BFF",
                }}
              >
                {currentPage} of {cptCodes?.data?.totalPages}
              </span>

              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === cptCodes?.pagination?.totalPages}
                style={{
                  margin: "5px",
                  padding: "10px 20px",
                  backgroundColor:
                    currentPage === cptCodes?.pagination?.totalPages
                      ? "#ccc"
                      : "#007BFF",
                  color: "#fff",
                  border: "1px solid #007BFF",
                  cursor:
                    currentPage === cptCodes?.pagination?.totalPages
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                Next
              </button>
            </div>
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <button
                onClick={() => {
                  setmodal(false);
                }}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#011434",
                  color: "#fff",

                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Save
              </button>
            </div>
          </div>
        </Box>
      </Modal>
      {confirmdeletemodal && (
        <DeleteModal
          name="Visit Reason"
          onClose={() => setconfirmdeletemodal(false)}
          onConfirm={confirmDelete}
        />
      )}
    </div>
  );
};

export default VisitReason;
const modalinsuranceStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  height: "80vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 4,
  outline: "none",
  overflowY: "auto",
};
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  height: "78vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 4,
  outline: "none",
  overflowY: "auto",
};
const tableHeaderStyle = {
  padding: "10px",
  borderBottom: "2px solid #ddd",
  textAlign: "left",
  fontWeight: "bold",
  backgroundColor: "#f4f4f4",
};

const tableCellStyle = {
  // padding: "2px",
  borderBottom: "1px solid #ddd",
};

const tableRowStyle = {
  borderBottom: "1px solid #ddd",
};
const editButtonStyle = {
  backgroundColor: "darkblue",
  marginBottom: 3,
  color: "white",
  border: "none",
  borderRadius: "4px",
  padding: "5px 10px",
  cursor: "pointer",
};
const deleteButtonStyle = {
  backgroundColor: "red",
  color: "white",
  border: "none",
  borderRadius: "4px",
  padding: "5px 10px",
  cursor: "pointer",
};
